import { ECustomerType } from '@aqx-core/common/api/account';

export const ACCOUNT_TYPE_OPTIONS = [ECustomerType.INDIVIDUAL, ECustomerType.CORPORATE];
